import { render } from "./EnIconDevelopment.vue?vue&type=template&id=3dfb48a0"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/icons/navigation/EnIconDevelopment.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3dfb48a0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3dfb48a0', __exports__)) {
    api.reload('3dfb48a0', __exports__)
  }
  
  module.hot.accept("./EnIconDevelopment.vue?vue&type=template&id=3dfb48a0", () => {
    api.rerender('3dfb48a0', render)
  })

}


export default __exports__